export default "__VITE_ASSET__CsL65cP0__"